import { FC, useState } from 'react';

import { useActions } from "../../redux/hooks";
import { TKeyboard } from "../../redux/slices/keyboards/types";

const KeyboardBlock: FC<{ keyboard: TKeyboard }> = ({ keyboard }) => {
    const { title, price, imageUrl, sizes, types } = keyboard

    const typeName = ['Wired', 'Wireless'];
    const [activeSize, setActiveSize] = useState<string>(sizes[0]);
    const [activeType, setActiveType] = useState<number>(keyboard.types.length > 0 ? keyboard.types[0] : 1);
    const [priceKeyboard, setPriceKeyboard] = useState(price)
    const [imageError, setImageError] = useState<boolean>(false);
    const { setKeyboards } = useActions()
    const handlerOnClickAddButton = () => {
        setKeyboards({
            ...keyboard, activeSize, activeType,
        })
    }

    return (<div className="keyboard-block--wrapper">
        <div className="keyboard-block">
            {imageError ? (
                 <div style={{height: '150px', paddingTop: '25%'}}>Error image</div>
              
            ) : (
                <img
                    className="keyboard-block__image"
                    src={imageUrl}
                    alt="Logo"
                    onLoad={() => setImageError(false)}
                    onError={() => setImageError(true)}
                />
            )}
            <div className="keyboard-block__selector">
                <ul>
                    {types.map((value, index) => {

                        return (<li
                            key={index}
                            onClick={() => setActiveType(value)}
                            className={activeType === value ? 'active' : ''}>
                            {typeName[value]}
                        </li>);
                    })}
                </ul>
                <ul>
                    {sizes.map((value, index) => {

                        return (<li
                            key={index}
                            onClick={() => setActiveSize(value)}
                            className={activeSize === value ? 'active' : ''}>
                            {value}
                        </li>);
                    })}
                </ul>
            </div>
            <div className="keyboard-block__bottom">
                <div className="keyboard-block__price">{priceKeyboard.toLocaleString('ru')}₽</div>
                <button onClick={() => handlerOnClickAddButton()} className="button button--outline button--add">
                    <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M10.8 4.8H7.2V1.2C7.2 0.5373 6.6627 0 6 0C5.3373 0 4.8 0.5373 4.8 1.2V4.8H1.2C0.5373 4.8 0 5.3373 0 6C0 6.6627 0.5373 7.2 1.2 7.2H4.8V10.8C4.8 11.4627 5.3373 12 6 12C6.6627 12 7.2 11.4627 7.2 10.8V7.2H10.8C11.4627 7.2 12 6.6627 12 6C12 5.3373 11.4627 4.8 10.8 4.8Z"
                            fill="white"
                        />
                    </svg>
                    <span>Add to Card</span>
                </button>
            </div>
        </div>
    </div>);
}

export default KeyboardBlock;
